<script lang="ts">
    import type { FiltersPopupDefinition } from 'header/types';
    import { FilterValue } from 'portlet/models/filterValue';

    interface Props {
        definition: FiltersPopupDefinition;
    }

    let { definition }: Props = $props();
    let json = $derived(JSON.stringify(definition, null, 2));
</script>

<ul class="filter-list">
    {#each definition.sections.localFilters as filter}
        <li class="filter-list__item filter" data-testid="dialog-filter-item">
            <span class="filter__key" data-testid="dialog-filter-key">{filter.filterKey}:</span
            ><span class="filtear__value" data-testid="dialog-filter-value"
                >{FilterValue.toString(filter.filterValue)}</span
            >
        </li>
    {/each}
    <details class="json">
        <summary>JSON</summary>
        <pre>{json}</pre>
    </details>
</ul>

{#if definition.sections.dataFrom}
    <p class="data-from">
        Data from:
        {definition.sections.dataFrom.date.toLocaleString()}
        {#if definition.sections.dataFrom.isDataPossiblyCached}
            <span class="data-from-cache">(?)</span>
        {/if}
    </p>
{/if}

<button onclick={definition.onReload}>Reload data</button>

<style lang="scss">
    @use '../../../../common/styles/mixins.scss' as m;

    .filter-list {
        @include m.reset-ul;
    }

    .filter {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .json {
        font-size: 0.8rem;
        border-top: 1px solid #000;

        pre {
            overflow-x: auto;
        }
    }
    .data-from {
        position: relative;
        span {
            padding-left: 5px;
            cursor: pointer;
            font-style: italic;

            &:hover::after {
                content: 'Data might have been read from cache';
                position: absolute;
                top: 26px;
                left: 0;
                font-size: 0.8em;
                background: rgba(0, 0, 0, 0.7);
                color: #fff;
                padding: 5px 16px;
                line-height: 1.6;
                border-radius: 6px;
            }
        }
    }
    .performance {
        margin: 1rem 0;
    }
</style>
